export const reviews = [
               {
                              id: 1,
                              img: 'https://labartisan.net/demo/kidsacademy/images/testimonial/testimonial_01.jpg',
                              name: 'John Doe',
                              job: 'Designer',
                              describtion: 'Rapidiously expedite granular imperatives before economically sound web services. Credibly actualize pandemic strategic themeplatformRapidiously expedite granular imperatives before economically sound web services. Credibly actualize pandemic strategic themeplatform'
               },
               {
                              id: 2,
                              img: 'https://labartisan.net/demo/kidsacademy/images/testimonial/testimonial_01.jpg',
                              name: 'Travis Green',
                              job: 'Developer',
                              describtion: 'Rapidiously expedite granular imperatives before economically sound web services. Credibly actualize pandemic strategic themeplatformRapidiously expedite granular imperatives before economically sound web services. Credibly actualize pandemic strategic themeplatform'
               },
               {
                              id: 3,
                              img: 'https://labartisan.net/demo/kidsacademy/images/testimonial/testimonial_01.jpg',
                              name: 'Net Ninja',
                              job: 'Data Analyst',
                              describtion: 'Rapidiously expedite granular imperatives before economically sound web services. Credibly actualize pandemic strategic themeplatformRapidiously expedite granular imperatives before economically sound web services. Credibly actualize pandemic strategic themeplatform'
               },
]